// extracted by mini-css-extract-plugin
module.exports = {"contents":"BaseUpsellStep_contents__iWfcv","logo":"BaseUpsellStep_logo__wAVys","heading":"BaseUpsellStep_heading__nnaVQ"};